import axios from 'axios';
import * as types from './types';
import apiUrls from "@/new-constants/apiUrls";

export default {

    // Si la lectura falla hay que enterarse: antes el error moría en un
    // console.error, el formulario se dibujaba vacío y parecía que los datos
    // guardados se habían perdido. Ahora se propaga y la vista avisa.
    async getBankData({ commit }) {
        try {
            const response = await axios.get(apiUrls.bankData);
            commit(types.SET_BANK_DATA, response.data.data);
            return response.data.data;
        } catch (error) {
            console.error('[bankData] no se pudieron leer los datos bancarios:', error);
            throw error;
        }
    },

    async putBankData({ commit }, data) {
        const response = await axios.put(apiUrls.bankData, data);
        commit(types.SET_BANK_DATA, response.data.data);
        return response.data.data;
    }
};
